
export class RoleModel {
    companyId: number;
    roleId: number;
    roleName: string;
    roleDesc: string;
    username: string;

    constructor(companyId: number, roleId: number, roleName: string, roleDesc: string, username: string) {
        this.companyId = companyId;
        this.roleId = roleId;
        this.roleName = roleName;
        this.roleDesc = roleDesc;
        this.username = username;
    }
}
